import styled from "styled-components"

export default {
    "BannerDiv": styled.div`
        position: relative;
        height: 216px;
    `,
    "BannerElem": styled.div`
        height: 216px;
    `,
    "BackgroundImg": styled.img`
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center center; 
        cursor: pointer;
    `,
    "PageDiv": styled.div`
        position: absolute;
        right: 16px;
        bottom: 16px;
        width: fit-content;
        background-color: #2A2929;
        border-radius: 9999px;
        padding: 4px 8px;

        & > p {
            display: flex;
            gap: 4px;
            ${({ theme }) => theme.font["tiny-semibold"]};
            color: ${({ theme }) => theme.color["white"]};

            span {
                ${({ theme }) => theme.font["tiny-regular"]};
                color: ${({ theme }) => theme.color["white"]};
            }
        }
    `
}


